import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d8ab8ac6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-outline rounded-3 overflow-hidden" }
const _hoisted_2 = { class: "session-list w-100" }
const _hoisted_3 = { class: "session-list__header fw-bold" }
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = { class: "session-list__header__title" }
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = { class: "session-list__header__title" }
const _hoisted_8 = ["aria-label"]
const _hoisted_9 = { class: "session-list__header__title" }
const _hoisted_10 = ["aria-label"]
const _hoisted_11 = { class: "session-list__header__title" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_13 = {
  key: 0,
  class: "session-list__loader"
}
const _hoisted_14 = {
  key: 1,
  class: "session-list__body"
}
const _hoisted_15 = {
  key: 2,
  class: "session-list__message"
}
const _hoisted_16 = { class: "nav-footer" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }

import EbarSessionListItem from '@/components/EbarSessionListItem/EbarSessionListItem.vue'
import { SessionListItemViewModel } from '../SessionListItem/SessionListItem.interfaces'
import PaginationBar from '@/components/PaginationBar'
import TableLoader from '@/components/TableLoader'
import ArrowUp from '@/icons/ArrowUp.vue'
import ArrowDown from '@/icons/ArrowDown.vue'
import ExpandArrows from '@/icons/ExpandArrows.vue'
import PersonCheckmark from '@/icons/PersonCheckmark.vue'
import { EbarSessionSortCriteria } from '../SessionRegistryStore'
import { MicroFilter } from '../SessionSearch/SessionSeach.interfaces'
import { checkIsEmpty } from '@/utils/is-empty'
import { computePaginatedSessions, computeTotalSessionPages } from '@/utils/pagination'
import { filterByDayAndTime } from '@/utils/filter'


import { defineComponent, defineProps, defineEmits, ref, computed } from 'vue'
const __default__ = defineComponent({
  name: 'EbarSessionList'
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    sessions: {},
    searchCriteria: {},
    microFilter: {},
    isLoading: { type: Boolean },
    isReady: { type: Boolean },
    disabled: { type: Boolean },
    showMySessionOnly: { type: Boolean },
    showOpenSeatsOnly: { type: Boolean }
  },
  emits: ['filtered-session-list-length-updated'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit

const props = __props

const sessionsPerPage = computed(() => sessionsExpanded.value ? 100000 : 8)
const currentPage = ref(1)
const filteredSessions = computed(computeFilteredSessions)
const totalSessionPages = computed(() => computeTotalSessionPages(filteredSessions.value, sessionsPerPage.value))
const paginatedSessions = computed(() => computePaginatedSessions(filteredSessions.value, sessionsPerPage.value, currentPage.value))
const sessionsExpanded = ref(false)

const firstIndex = computed(() => !paginatedSessions.value.length ? 0 : 1 + sessionsPerPage.value * (currentPage.value - 1))
const lastIndex = computed(() => !paginatedSessions.value.length ? 0 : firstIndex.value + paginatedSessions.value.length - 1)
const isSortDescending = ref(true)
const sortCriteria = ref(EbarSessionSortCriteria.Dates)

const showMessage = computed(() => {
  return !paginatedSessions.value.length && props.isReady && !props.isLoading
})

const messageValue = computed(() => {
  return 'There are no available sessions' + (props.searchCriteria ? ' for your search criteria' : '')
})

function toggleSort(criteriaClicked: EbarSessionSortCriteria) {
	if (criteriaClicked == sortCriteria.value)
	{
		isSortDescending.value = !isSortDescending.value
	}
	else
	{
		isSortDescending.value = true
	}
	sortCriteria.value = criteriaClicked
}

function sessionExpand() {
  currentPage.value = 1
  sessionsExpanded.value = !sessionsExpanded.value
}

function computeFilteredSessions() {
  function filterSessions() {
    let filtered: SessionListItemViewModel[] = Array.from(props.sessions)
    filtered = filtered.filter((session) => session.localEndDateTime > new Date())

    if (checkIsEmpty(props.searchCriteria)
        && !props.microFilter?.days
        && !props.microFilter?.times
        && !props.showMySessionOnly
        && !props.showOpenSeatsOnly) {
      return filtered
    }

    if (!checkIsEmpty(props.searchCriteria)) {
      const upperCaseCriteria = props.searchCriteria.toUpperCase()

      filtered = filtered.filter((session) => {
        const upperCaseStartEndDate = session.startEndDate.toUpperCase()
        const upperCaseStartEndTime = session.localStartEndTime.toUpperCase()
        const upperCaseDateFullMonth = session.localStartDateTime.toLocaleString('en-us', {month: 'long', day: 'numeric', year: 'numeric'}).toUpperCase() + ' - ' +
          session.localEndDateTime.toLocaleString('en-us', {month: 'long', day: 'numeric', year: 'numeric'}).toUpperCase()
        const upperCaseDayOfWeek = (session.localStartDateTime.toLocaleString('en-us',{weekday: 'long'}) + 's').toUpperCase()

        return (
          upperCaseStartEndDate.includes(upperCaseCriteria) ||
          upperCaseStartEndTime.includes(upperCaseCriteria) ||
          upperCaseDateFullMonth.includes(upperCaseCriteria) ||
          upperCaseDayOfWeek.includes(upperCaseCriteria)
        )
      })
    }

    if (props.showOpenSeatsOnly) {
      filtered = filtered.filter((session) => !session.isFull)
    }

    if (props.showMySessionOnly) {
      filtered = filtered.filter((session) => session.showRegistered)
    }

    filtered = filterByDayAndTime(filtered, props.microFilter)

    currentPage.value = 1
    return filtered
  }

  var workingArray = filterSessions()
  var enrolledSession = workingArray.find(sesh => sesh.showRegistered)
  workingArray = workingArray.filter(sesh => !sesh.showRegistered)
  if (sortCriteria.value == EbarSessionSortCriteria.Sessions) {
    workingArray.sort((leftElement, rightElement) => (leftElement.localStartDateTime.getDay() - rightElement.localStartDateTime.getDay()))
  }
  if (sortCriteria.value == EbarSessionSortCriteria.Time) {
    workingArray.sort((leftElement, rightElement) => ((leftElement.localStartDateTime.getHours() - rightElement.localStartDateTime.getHours()) * 60
      + (leftElement.localStartDateTime.getMinutes() - rightElement.localStartDateTime.getMinutes())))
  }
  if (sortCriteria.value == EbarSessionSortCriteria.Dates) {
    workingArray.sort((leftElement, rightElement) => (leftElement.localStartDateTime.getTime() - rightElement.localStartDateTime.getTime()))
  }
  if (sortCriteria.value == EbarSessionSortCriteria.Availability) {
    workingArray.sort((leftElement, rightElement) => ((leftElement.isFull === rightElement.isFull) ? 0 : rightElement.isFull ? -1 : 1))
  }
  if (!isSortDescending.value) {
    workingArray.reverse()
  }
  if (enrolledSession) {
    workingArray.unshift(enrolledSession)
  }
  currentPage.value = 1

  emit('filtered-session-list-length-updated', workingArray.length)

  return workingArray
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", _hoisted_3, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", null, [
            _createVNode(PersonCheckmark, { class: "enroll-icon ms-3" })
          ]),
          _createElementVNode("th", null, [
            _createElementVNode("button", {
              class: "session-list__header__sort-button",
              type: "button",
              "aria-label": 'sort by day of week from ' + (sortCriteria.value === _unref(EbarSessionSortCriteria).Sessions && isSortDescending.value ? 'saturday to sunday' : 'sunday to saturday'),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleSort(_unref(EbarSessionSortCriteria).Sessions)))
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createTextVNode(" Sessions "),
                (sortCriteria.value !== _unref(EbarSessionSortCriteria).Sessions)
                  ? (_openBlock(), _createBlock(ExpandArrows, {
                      key: 0,
                      class: "arrow-slot",
                      "aria-hidden": "true"
                    }))
                  : (isSortDescending.value)
                    ? (_openBlock(), _createBlock(ArrowDown, {
                        key: 1,
                        class: "arrow-slot",
                        "aria-hidden": "true"
                      }))
                    : (_openBlock(), _createBlock(ArrowUp, {
                        key: 2,
                        class: "arrow-slot",
                        "aria-hidden": "true"
                      }))
              ])
            ], 8, _hoisted_4)
          ]),
          _createElementVNode("th", null, [
            _createElementVNode("button", {
              class: "session-list__header__sort-button",
              type: "button",
              "aria-label": 'sort by time of day from ' + (sortCriteria.value === _unref(EbarSessionSortCriteria).Time && isSortDescending.value ? 'latest to earliest' : 'earliest to latest'),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleSort(_unref(EbarSessionSortCriteria).Time)))
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createTextVNode(" Time "),
                (sortCriteria.value !== _unref(EbarSessionSortCriteria).Time)
                  ? (_openBlock(), _createBlock(ExpandArrows, {
                      key: 0,
                      class: "arrow-slot",
                      "aria-hidden": "true"
                    }))
                  : (isSortDescending.value)
                    ? (_openBlock(), _createBlock(ArrowDown, {
                        key: 1,
                        class: "arrow-slot",
                        "aria-hidden": "true"
                      }))
                    : (_openBlock(), _createBlock(ArrowUp, {
                        key: 2,
                        class: "arrow-slot",
                        "aria-hidden": "true"
                      }))
              ])
            ], 8, _hoisted_6)
          ]),
          _createElementVNode("th", null, [
            _createElementVNode("button", {
              class: "session-list__header__sort-button",
              type: "button",
              "aria-label": 'sort by date from ' + (sortCriteria.value === _unref(EbarSessionSortCriteria).Dates && isSortDescending.value ? 'latest to earliest' : 'earliest to latest'),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleSort(_unref(EbarSessionSortCriteria).Dates)))
            }, [
              _createElementVNode("div", _hoisted_9, [
                _createTextVNode(" Dates "),
                (sortCriteria.value !== _unref(EbarSessionSortCriteria).Dates)
                  ? (_openBlock(), _createBlock(ExpandArrows, {
                      key: 0,
                      class: "arrow-slot",
                      "aria-hidden": "true"
                    }))
                  : (isSortDescending.value)
                    ? (_openBlock(), _createBlock(ArrowDown, {
                        key: 1,
                        class: "arrow-slot",
                        "aria-hidden": "true"
                      }))
                    : (_openBlock(), _createBlock(ArrowUp, {
                        key: 2,
                        class: "arrow-slot",
                        "aria-hidden": "true"
                      }))
              ])
            ], 8, _hoisted_8)
          ]),
          _createElementVNode("th", null, [
            _createElementVNode("button", {
              class: "session-list__header__sort-button",
              type: "button",
              "aria-label": 'sort by availability from ' + (sortCriteria.value === _unref(EbarSessionSortCriteria).Availability && isSortDescending.value ? 'unavailable to available' : 'available to unavailable'),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (toggleSort(_unref(EbarSessionSortCriteria).Availability)))
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createTextVNode(" Availability "),
                (sortCriteria.value !== _unref(EbarSessionSortCriteria).Availability)
                  ? (_openBlock(), _createBlock(ExpandArrows, {
                      key: 0,
                      class: "arrow-slot",
                      "aria-hidden": "true"
                    }))
                  : (isSortDescending.value)
                    ? (_openBlock(), _createBlock(ArrowDown, {
                        key: 1,
                        class: "arrow-slot",
                        "aria-hidden": "true"
                      }))
                    : (_openBlock(), _createBlock(ArrowUp, {
                        key: 2,
                        class: "arrow-slot",
                        "aria-hidden": "true"
                      }))
              ])
            ], 8, _hoisted_10)
          ]),
          _hoisted_12
        ])
      ]),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createVNode(_unref(TableLoader))
          ]))
        : (_openBlock(), _createElementBlock("tbody", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedSessions.value, (event) => {
              return (_openBlock(), _createBlock(EbarSessionListItem, {
                key: event.sessionId,
                "model-value": event,
                disabled: _ctx.disabled,
                "is-last-row": event == paginatedSessions.value[paginatedSessions.value.length-1]
              }, null, 8, ["model-value", "disabled", "is-last-row"]))
            }), 128))
          ])),
      (showMessage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(messageValue.value), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("span", null, [
        _createTextVNode(" Showing " + _toDisplayString(firstIndex.value) + " - " + _toDisplayString(lastIndex.value) + " of " + _toDisplayString(filteredSessions.value.length) + " • ", 1),
        _createElementVNode("button", {
          class: "expand-btn",
          onClick: sessionExpand
        }, [
          (sessionsPerPage.value != 100000)
            ? (_openBlock(), _createElementBlock("span", _hoisted_17, "View All"))
            : (_openBlock(), _createElementBlock("span", _hoisted_18, "Collapse"))
        ])
      ]),
      _withDirectives(_createVNode(_unref(PaginationBar), {
        "pagination-value": currentPage.value,
        "onUpdate:paginationValue": _cache[4] || (_cache[4] = ($event: any) => ((currentPage).value = $event)),
        "total-pages": totalSessionPages.value,
        spread: 2,
        disabled: _ctx.disabled
      }, null, 8, ["pagination-value", "total-pages", "disabled"]), [
        [_vShow, totalSessionPages.value > 1]
      ])
    ])
  ]))
}
}

})